export var SseController = {
  messageHandlers: new Map(),

  init: function (url) {
    SseController.eventSource = new EventSource(url);
    SseController.eventSource.onmessage = event => {
      let message = JSON.parse(event.data);
      SseController.messageHandlers.forEach((handler, key) => {
        if (message.type == key) {
          handler(message);
        }
      });
    };
  },
  addMessageHandler: function (messageType, handler) {
    SseController.messageHandlers.set(messageType, handler);
  },
  removeMessageHandler: function (messageType) {
    SseController.messageHandlers.delete(messageType);
  }
};
